import React, { useEffect, useState } from 'react';
import { MOBILE_BREAKPOINT } from '../../Utils/responsive';
import MyAccountWeb from './web';
import MyAccountMob from './mob';

const MyAccount = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile ? <MyAccountMob /> : <MyAccountWeb />;
};

export default MyAccount;
